import React from 'react'
import VBEvent from '../components/VBEvent'

const PublicVBEventView = ({ match }) => {
  return <VBEvent isPublic={true} vbEventId={match.params.id} />
}

export default PublicVBEventView
